import FolderOffIcon from '@mui/icons-material/FolderOff';
import { Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  handleOpenAddBlacklistDialog(): void;
}

const NoBlacklistsFound: React.FC<Props> = ({ handleOpenAddBlacklistDialog }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.noBlacklistsFound}>
      <FolderOffIcon className={classes.icon} />
      <Stack gap={1} alignItems={'center'}>
        <Typography className={classes.greyText}>{t('noGlobalBlacklist')}</Typography>
        <PaiLink
          text={t('createNewBlacklist')}
          size={'lg'}
          variant={'primary'}
          underline={'always'}
          action={handleOpenAddBlacklistDialog}
        />
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  noBlacklistsFound: {
    height: '100%',
    overflow: 'auto',
    background: '#FFF',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
  },
  icon: {
    fontSize: theme.typography.pxToRem(80),
    marginBottom: '32px',
    color: theme.palette.greys.medium,
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
}));

export default NoBlacklistsFound;
